/**
 * Demo stubs for overtimeApi methods.
 * Returns safe empty/success responses to prevent crashes in demo mode.
 */
export const demoOvertimeService = {
  previewImport: async () => ({ success: true, data: { rows: [], errors: [], total: 0 } }),
  importRecords: async () => ({ success: true, data: { imported: 0, skipped: 0, errors: [] } }),
  getWeeklySummary: async () => ({ success: true, data: { rows: [], total: 0, thresholds: { normal_max: 40, warning_min: 48, caution_min: 44, violation_min: 52 } } }),
  getAlerts: async () => ({ success: true, data: { alerts: [], total: 0, counts: { critical: 0, high: 0, medium: 0 }, thresholds: { normal_max: 40, warning_min: 48, caution_min: 44, violation_min: 52 } } }),
  getMonthlyTrend: async () => ({ success: true, data: { rows: [], total: 0 } }),
  getRecords: async () => ({ success: true, data: { records: [], total: 0 } }),
};
